module.exports = __webpack_public_path__ + "img/ic_activity_cmt.c9ec99bf.svg";